const STYLE_ID = 'modal-manager-styles';

/** Installs the shared modal stylesheet once per document. */
export function installModalStyles(cssText: string, doc: Document = document): void {
  if (doc.getElementById(STYLE_ID)) return;
  const styleSheet = doc.createElement('style');
  styleSheet.id = STYLE_ID;
  styleSheet.textContent = cssText;
  doc.head.appendChild(styleSheet);
}
